export var USER_TYPE = {
  Guest: 1,
  Person: 2
};

/**
 * 变更的协作者 uids
 */

/**
 * 协作者人数变化事件
 */

/**
 * 推送消息事件类型
 */
export var ServerMessageNoticeEventType = /*#__PURE__*/function (ServerMessageNoticeEventType) {
  ServerMessageNoticeEventType["COLLAB_COUNT_CHANGE"] = "COLLAB_COUNT_CHANGE";
  ServerMessageNoticeEventType["EXPIRED_TIME_CHANGE"] = "EXPIRED_TIME_CHANGE";
  return ServerMessageNoticeEventType;
}({});

/**
 * 协作者信息聚合
 *
 * 一、继续保留现网的透传事件逻辑， 【’这里和 DC 同事沟通后，先只做数据透传，暂时不做数据处理逻辑‘】
 *
 * 二、CollaborateAggregate 支持数据缓存和拉取资料逻辑，详细功能如下：
 * 1、提供协作者数据缓存，数据存在 collabAllInfoList 里；
 * 2、集成了拉取个人资料逻辑， 业务方不需要再自己拉取了；
 * 3、避免同一个 uid 重复请求；
 * 4、添加限频拉取逻辑，业务可以自行设置拉取频率 collaborateAggregate.throttleInterval；
 * 5、提供 getUserMarkName api， 有缓存优先从缓存中返回；
 *
 */
//# sourceMappingURL=aggregate.js.map